export function canDeleteSpecies(user) {
    const role = String(user?.role_name || user?.role || "")
        .trim().toLowerCase().replaceAll("_", " ").replaceAll("-", " ");
    return role === "owner";
}
